import Component from './chart_bar.vue'
export default Component
